import { farmUseCase } from "@/api/modules/farm/useCases";
import { managementSectorUseCases } from "@/api/modules/sector/useCases";

import calcManagement from "@/mixins/calcManagement";

import moment from "moment";


import { soilUseCase } from "@/api/modules/soil/useCases";
import { managementFarmDapUseCase } from "@/api/modules/farms_dap/useCases/getManagementFarmDAP";

import { checkIfFarmDapExists } from "@/api/modules/farms_dap/useCases/checkIfExistsFarmDap";

import { deleteManagementBySectorAndInterval } from "@/api/modules/management/useCase/deleteBySectorAndInterval";
import { getLastRecordFromManagementByIdSector } from "../api/modules/management/useCase/getLastRecordFromManagement";

import { updateOffsetSectorByIdSector } from "@/api/modules/log_sector/useCase/updateByIdSector";
import { showLogSectorByIdAndTimeUseCase } from "@/api/modules/log_sector/useCase/showByTimeAndIdSector";
import { createLogSectorUseCase } from "@/api/modules/log_sector/useCase/create";
import { deleteLogSectorByIdUseCase } from "@/api/modules/log_sector/useCase/delete";

import { deleteManagementByIdSector } from "@/api/modules/management/useCase/deleteByIdSector";

export default {
  mixins: [calcManagement],
  methods: {
    async updateFarmEditorRefact({ name, fkEditor, idItem, formType }) {
      // console.log('creating farm', {name, fkEditor, idItem, formType})
      if (formType === "add") {
        const farmID = await farmUseCase().getFarmIdByName.execute(name);
        await farmUseCase().updateFkEditor.execute(farmID, fkEditor);
      } else {
        await farmUseCase().updateFkEditor.execute(idItem, fkEditor);
      }
    },
    async updateSoilEditorRefact({ name, fkEditor, idSoil, formType }) {
      if (formType === "add") {
        const soilId = await soilUseCase().getSoilIdByName.execute(name);
        // console.log({soilId})
        await soilUseCase().updateFkEditor.execute(soilId, fkEditor);
      } else {
        await soilUseCase().updateFkEditor.execute(idSoil, fkEditor);
      }
    },
    async getValveInfo(data) {
      const { ID, NAME, valves } = data.SECTOR;
      let FK_SECTOR = null;
      if (this.formType == "edit") {
        FK_SECTOR = ID;
      } else {
        const sector = await managementSectorUseCases().showByName.execute(
          NAME
        );
        FK_SECTOR = sector.ID;
      }
      const volumeValve = valves.find(v => v.NAME === NAME) || valves[0];
      return {
        FK_VALVE: volumeValve.ID,
        FK_SECTOR,
        NAME: volumeValve.NAME,
      };
    },
    async saveOffSetDap(data) {
      // Data inicial de manejo no futuro: nada a gravar (o recalc também não teria dias a processar).
      const managementStart = data.MANAGEMENT.VOLUME_DATE
        ? moment(data.MANAGEMENT.VOLUME_DATE).format("YYYY-MM-DD")
        : moment().subtract(1, "months").format("YYYY-MM-DD");
      if (moment(managementStart).isAfter(moment().format("YYYY-MM-DD"))) return;

      let TIME = moment().format("YYYY-MM-DD");

      let {
        MANAGEMENT: { OFFSET_DAP, ID_SECTOR },
        SECTOR: { ID },
      } = data;

      const sectorId = ID_SECTOR || ID;

      if (this.formType == "edit") {
        let previousLogSector = await showLogSectorByIdAndTimeUseCase().execute(
          sectorId,
          TIME
        );

        //Caso não tiver algo no banco então terá que salvar
        // Não será comum, mas é só uma garantia na realização dos testes
        if (!previousLogSector) {
          await createLogSectorUseCase().execute({
            ID_SECTOR: sectorId,
            TIME,
            OFFSET: OFFSET_DAP,
          });
        }

        if (previousLogSector && previousLogSector.OFFSET !== OFFSET_DAP) {
          await updateOffsetSectorByIdSector().execute(sectorId, OFFSET_DAP);
        }
      } else {
        await createLogSectorUseCase().execute({
          ID_SECTOR: sectorId,
          TIME,
          OFFSET: OFFSET_DAP,
        });
      }
    },
    async deleteManagementDatasFromSector(ID) {
      await deleteLogSectorByIdUseCase().execute(ID);
      await deleteManagementByIdSector().execute(ID);
      await managementSectorUseCases().deleteById.execute(ID);
    },
    async updateSectorHandler(SECTOR_PROPS) {
      //Caso for editar um setor que antes não era de manejo, irá adicionar o ID no management
      if (!SECTOR_PROPS.MANAGEMENT.ID_SECTOR) {
        SECTOR_PROPS.MANAGEMENT.ID_SECTOR = SECTOR_PROPS.SECTOR.ID;
      }

      const sectorAlreadyExists =
        await managementSectorUseCases().checkManagementSector.execute(
          SECTOR_PROPS.MANAGEMENT.ID_SECTOR
        );

      if (!sectorAlreadyExists) {
        // console.log(">>> Criando setor de manejo");
        await managementSectorUseCases()["add"].execute(
          SECTOR_PROPS.MANAGEMENT
        );
      }

      // Caso apenas estiver editando o setor que antes já era de manejo
      else {
        //Apagar dados posteriores da data de colheita para evitar lixo no banco
        if (SECTOR_PROPS.HAS_CHANGED_DATE_CROP) {
          //Buscar último dia de manejo e comparar a data de colheita
          // Se a data de colheita for menor do que a data de manejo, então apaga os dados após a data de manejo

          const managementData =
            await getLastRecordFromManagementByIdSector().execute(
              SECTOR_PROPS.MANAGEMENT.ID_SECTOR
            );

          const managementTime = managementData ? managementData.TIME : null;
          const isBeforeManagementDate = managementTime
            ? moment(SECTOR_PROPS.MANAGEMENT.DATE_CROP).isBefore(managementTime)
            : false;

          if (isBeforeManagementDate) {
            await deleteManagementBySectorAndInterval().execute(
              SECTOR_PROPS.MANAGEMENT.ID_SECTOR,
              SECTOR_PROPS.MANAGEMENT.DATE_CROP
            );

            //Indicador para saber quando usar a data de COLHEITA no cálculo de volume
            this.recalcUntilDateCrop = true;
          }
        }

        await managementSectorUseCases()[this.formType].execute(
          SECTOR_PROPS.MANAGEMENT
        );
      }

      const oldValve = SECTOR_PROPS.SECTOR.oldValves;
      //Se não foi trocado de válvula então será null, caso tenha trocado de válvula ou terá a string com a data
      //ou será "" (Caso tenha apagado a data)
      const oldManagementInitialDate =
        SECTOR_PROPS.SECTOR.oldManagementInitialDate;

      const hasChangedManagementInitialDate = oldManagementInitialDate !== null;

      const hasChangedValves = !!oldValve && oldValve.length;

      // Comparar apenas as válvulas de volume
      const volumeValveName = (valves, sectorName) =>
        (valves.find(v => v.NAME === sectorName) || valves[0])?.NAME;

      const hasAddedNewValve =
        hasChangedValves &&
        volumeValveName(oldValve, SECTOR_PROPS.SECTOR.NAME) !==
        volumeValveName(SECTOR_PROPS.SECTOR.valves, SECTOR_PROPS.SECTOR.NAME)

      const getPluviometerId = sensors => {
        if (!sensors) return null;
        const p = sensors.find(s => s.NAME_MODEL && s.NAME_MODEL.includes('PLUVIOMETRO'));
        return p ? p.ID : null;
      };
      const oldPluviometerId = SECTOR_PROPS.SECTOR.oldPluviometerId ?? null;
      const newPluviometerId = getPluviometerId(SECTOR_PROPS.SECTOR.sensors);
      const hasChangedPluviometer = oldPluviometerId !== newPluviometerId;

      const SECTOR_ID =
        SECTOR_PROPS.MANAGEMENT.ID_SECTOR || SECTOR_PROPS.SECTOR.ID;
      //Quando trocar de válvula ou trocar de data de manejo, irá recalcular tudo
      if (hasAddedNewValve || hasChangedManagementInitialDate) {
        if (hasAddedNewValve) {
          // console.log(
          //   ">>> Calculando tudo de novo pois foi trocado de válvula "
          // );
        }
        if (hasChangedManagementInitialDate) {
          // console.log(
          //   ">>> Calculando tudo de novo pois foi trocado a data inicial de manejo para ",
          //   SECTOR_PROPS.MANAGEMENT.VOLUME_DATE || "Vazio"
          // );
        }
        // Recompute via backend (upsert preserva os alegados). A invalidação por mudança de fonte
        // vai como flag no recalc (return abaixo) — não se apaga mais o MANAGEMENT inteiro.
        await this.saveOffSetDap(SECTOR_PROPS);
      }
      //Editar um setor que antes não tinha válvula ou Editar um setor sem mudar a válvula
      else {
        // Volume não é mais dado do setor (é da válvula) — o sinal de "setor ainda não passou pelo
        // manejo" vem de MANAGEMENT, não mais de CROP.VOLUME.
        const lastManagementRecord =
          await getLastRecordFromManagementByIdSector().execute(SECTOR_ID);

        //Estou editando um setor que antes não era de manejo e agora irá ser de manejo
        //Também recalcula se o pluviômetro foi adicionado ou trocado
        if (!lastManagementRecord || hasChangedPluviometer) {
          await this.saveOffSetDap(SECTOR_PROPS);
        }
      }

      // Fonte mudou → invalida o alegado da grandeza no recalc (o SectorForm repassa as flags).
      return {
        resetVolumeInputs: hasAddedNewValve,
        resetRainfallInputs: hasChangedPluviometer,
      };
    },
  },
};
